<div class="row justify-content-center">
  <div class="d-flex justify-content-center w-100 products-container">
    @if (isLoading && !products.length) {
      <mat-spinner mode="indeterminate" diameter="50"></mat-spinner>
    }

    @if (products.length > 1) {
      @for (product of products; track product) {
        <div
          class="product d-flex justify-content-space-between"
          [class.selected]="product.id === selectedProduct.id"
          (click)="productClicked(product)"
        >
          <div class="d-flex flex-column justify-content-space-between align-items-start">
            <div class="product-title">{{ product.trialLabel || product.title }}</div>
            <div class="price-container">
              <span class="full-price">{{ product.compareAtPriceLabel }}</span> →
              {{ product.priceLabel }}
            </div>
          </div>
          <div
            class="d-flex flex-column align-items-center justify-content-center gap-4 flex-shrink-0"
          >
            <div class="product-price">
              {{ product.dailyPriceLabel }}
            </div>
            <span class="daily-hint" i18n="@@perDay">per day</span>
          </div>
          @if (product.isBestDeal) {
            <div class="product-badge bg-red" i18n="@@bestDeal">Best Deal</div>
          }
          @if (product.isMostPopular) {
            <div class="product-badge bg-tealish" i18n="@@mostPopular">Most Popular</div>
          }
          @if (product.trialLabel) {
            <span class="product-badge bg-green">{{ product.title }}</span>
          }
        </div>
      }
    }

    @if (products.length === 1) {
      <div class="lead text-center">
        <strong>{{ products[0].title }}</strong>
        <ng-container i18n="@@checkoutSingleProductOnly">
          - Only {{ products[0].priceLabel }}</ng-container
        >
        <span class="ml-5 red-color crossed">{{ products[0].compareAtPriceLabel }}</span>
      </div>
    }
  </div>
</div>

<!-- Content projection slot for custom content -->
<ng-content></ng-content>

@if (moneyBackGuaranteeMode === 'small') {
  <div class="d-flex mt-20 justify-content-center">
    <div class="safe-label d-flex justify-content-center align-items-center">
      <div class="small-moneyback-icon"></div>
      <span class="ms-5" i18n="@@moneyBackGuaranteeSmall">30-day money-back guarantee</span>
    </div>
  </div>
}

<div class="d-flex flex-column align-items-center justify-content-center mt-24">
  @if (selectedProduct) {
    <app-express-pay
      [amount]="initialCharge"
      [currency]="selectedProduct.currency"
      [createCharge]="createSubscriptionCharge"
      [requestEmail]="!email"
      [insufficientFundsAction]="insufficientFundsAction"
      [processingLabel]="processingLabel"
      [continueButtonTitle]="currentPurchaseButtonTitle"
      (walletClicked)="expressPayClicked()"
      (emailCollected)="adoptWalletEmail($event)"
      (cancelled)="canceledPurchase.emit()"
      (otherOptionsClicked)="otherPaymentMethodsClicked()"
      (succeeded)="handlePaymentSuccess()"
      (chargeFailed)="handleChargeFailure($event)"
    ></app-express-pay>
  } @else {
    <!-- Products haven't loaded yet; the CTA still has to take a click somewhere. -->
    <button mat-flat-button class="tagus" (click)="purchaseButtonClicked()">
      {{ currentPurchaseButtonTitle }}
    </button>
  }
</div>

@if (isSafeCheckoutNoteShown) {
  <div class="mt-20 d-flex flex-column align-items-center col-12">
    <div class="payment-promo" i18n="@@guaranteedSafeCheckout">Guaranteed safe checkout</div>
    <div class="options-logos mt-10 w-100"></div>
  </div>
}

@if (moneyBackGuaranteeMode === 'large') {
  <div class="money-back-guarantee mt-20 border-radius p-20">
    <div class="d-flex align-items-center gap-8">
      <div class="moneyback-icon"></div>
      <div class="fs-24 fw-bold">
        <ng-container i18n="@@moneyBackGuaranteeTitlePart1">30-Day Money-Back</ng-container>
        <span class="main-color" i18n="@@moneyBackGuaranteeTitlePart2"> Guarantee</span>
      </div>
    </div>
    <p class="fs-14 mt-10" i18n="@@moneyBackGuaranteeParagraph1">
      Explore our app with confidence, backed by our Money-Back Guarantee. Our expertly crafted
      service ensures a risk-free experience for you to dive into the full potential of our app.
    </p>
    <p class="fs-14">
      <ng-container i18n="@@moneyBackGuaranteeParagraph2Prefix">
        If you don't witness the expected results within 30 days of your purchase, we stand by our
        commitment to provide a hassle-free refund. For detailed information, please refer to our
      </ng-container>
      <a rel="noreferrer" href="https://www.getpeech.com/subscription-terms" target="_blank"
        ><ng-container i18n="@@subscriptionPolicy">Subscription Policy</ng-container></a
      >
      <ng-container i18n="@@period">.</ng-container>
    </p>
  </div>
}

@if (isPeopleBadgeShown) {
  <div class="mt-20 d-flex flex-column align-items-center col-12">
    <div class="payment-promo" i18n="@@joinMillionsSuccessfulUsers">
      Join millions of successful users
    </div>
    <div class="people-badge-icon mt-10 w-100"></div>
  </div>
}
